export default theme => ({
  textContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'space-between',
  },
  label: {
    color: '#555',
  },
  sqFt: {
    marginLeft: 20,
    color: '#555',
  },
});
